// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_BAP","cls2":"JJHomePageSearch-cls2_mQk JJHomePageSearch-cls1_BAP"};